package gr.tech.GRAttestation.models.stores

enum class STORE_STATUS(val bit: Short, val status: String) {
    DELETED(0, "DELETED"),
    ACTIVE(1, "ACTIVE");

    companion object {
        fun parseStatus(status: String): STORE_STATUS {
            return when (status.lowercase()) {
                "active" -> STORE_STATUS.ACTIVE
                "deleted" -> STORE_STATUS.DELETED
                else -> STORE_STATUS.ACTIVE
            }
        }

        fun parseStatus(status: Short): STORE_STATUS {
            return when (status) {
                1.toShort() -> STORE_STATUS.ACTIVE
                0.toShort() -> STORE_STATUS.DELETED
                else -> STORE_STATUS.ACTIVE
            }
        }
    }
}